export enum ChatRole {
  USER = "user",
  CHAT = "cfc",
}

export interface IChat {
  section?: string;
  subsection?: string;
  id: number;
  role: ChatRole;
  message: string;
  image?: File;
  files?: string[];
  isError?: boolean;
  image_url?: string;
  url?: string;
  containsFile?: boolean;
  isLastChatMessage: boolean;
}
